import { render, staticRenderFns } from "./ProviderTaskDialog.vue?vue&type=template&id=4bd10cc0&"
import script from "./ProviderTaskDialog.vue?vue&type=script&lang=js&"
export * from "./ProviderTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports